import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from './router';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { AppMutations } from '@/app/app.keys';
import store from '@/store';
import i18n from '@/i18n';

Vue.use(VueAxios, axios);
axios.defaults.baseURL = '/api/v1';
axios.defaults.sessionRefresh = '/session/refresh-session';
axios.defaults.params = {};

const pwResetPattern = /\/account\/password-reset/;
const attachmentsDownloadPattern = /\/attachments\/.{6,7}\?type=/;

const getToken = () => {
  return localStorage.getItem('tol-token');
};

axios.interceptors.request.use(
  config => {
    // might want to have a white list of url's that
    // don't need the auth token
    if (config.baseURL === axios.defaults.baseURL && !config.headers.Authorization) {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  error => {
    Promise.reject(error.response);
  }
);

// for urls other than the login one if token is invalid (401)  require re-login
// return all other errors as is
axios.interceptors.response.use(
  response => response,
  error => {
    console.log(typeof error.response.data);
    if (
      !pwResetPattern.test(error.config.url) &&
      error.config.url !== `${error.config.baseURL}/login` &&
      error.response.status === 401
    ) {
      store.dispatch(TolErrorsActions.SetError, { message: i18n.t('login.errors.loginAgain') });
      store.dispatch(TolErrorsActions.SetKeepOnce);
      localStorage.setItem('tol-token', null);
      localStorage.setItem('tol-refresh-token', null);
      store.commit(AppMutations.DismissSession);
      router.push('/login');
    }
    if (error.response.status && (error.response.status === 404 || error.response.status === 403)) {
      //dont throw a 404 if a user is viewinig a resource that has attachments that
      //they do not have access to
      if (!attachmentsDownloadPattern.test(error.config.url)) {
        router.replace({ path: `/404` }).catch(() => {});
      }
    }
    if (
      error.response.status &&
      ([502, 503].includes(error.response.status) ||
        error.response.data.toString().includes('ECONNREFUSED'))
    ) {
      store.dispatch(TolErrorsActions.SetServiceUnavailable);
    }
    return Promise.reject(error.response);
  }
);
